module.exports = __webpack_public_path__ + "static/media/with-wireless-chager.8c28ee3b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/airpods/with-wireless-chager.jpeg
// module id = 2104
// module chunks = 0